import { all, call, put, takeLatest } from "redux-saga/effects";
import { getLGL } from "@services/api";
import { GET_LGL_REQ } from "../reducers/actionTypes";
import { actions } from "../reducers/lglReducer";

function* getLGLWorker() {
  try {
    const { data } = yield call(() => getLGL());
    yield put(actions.getLGLSuccess(data));
  } catch (e) {
    console.log(e);
    yield put(actions.getLGLFail());
  }
}

export default function* () {
  yield all([takeLatest(GET_LGL_REQ, getLGLWorker)]);
}
